import { EMPTY } from "rxjs";
import { filter, map, retry, switchMap } from "rxjs/operators";
import { selectCoop } from "../../../selectors/selectCoopInfo";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionGetCoopEventNoticesResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopGetEventNotices = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionCoopInfo.Received ||
            action.type === TypeActionCoopInfo.GetCoopEventNotices;
    }), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectOwnPlayerId(state);
        var coop = selectCoop(state);
        if (coop) {
            var coopId = coop.id;
            return deps
                .netSend({
                id: CommandCode.CoopMessageInfo,
                props: {
                    coopId: coopId,
                    playerId: playerId,
                },
            })
                .pipe(map(actionGetCoopEventNoticesResponse), retry());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopGetEventNotices.ts
// module id = 1802
// module chunks = 3